import { gql } from "@apollo/client";

import { EventTypeFilterFragment } from "./EVENT_TYPE_FILTERS";

export const useFilteredEventsFragment = gql`
  fragment useFilteredEventsFragment on Game {
    id
    home {
      id
    }
    events {
      id
      person {
        id
      }
      team {
        id
      }
      ...EventTypeFilterFragment
    }
  }
  ${EventTypeFilterFragment}
`;

export default function useFilteredEvents({ game, activeEventTypeFilters, homeFilterPersonId, awayFilterPersonId }) {
  const filteredEventIds = game?.events
    .filter((event) => {
      if (!activeEventTypeFilters.find((f) => f.filter(event))) return false;
      // non-team events should be visible for everyone
      if (!event.team) return true;
      if (event.team.id === game.home.id) {
        return (
          homeFilterPersonId === "ALL" ||
          (Array.isArray(homeFilterPersonId) && homeFilterPersonId.includes(event.person?.id))
        );
      } else {
        return (
          awayFilterPersonId === "ALL" ||
          (Array.isArray(awayFilterPersonId) && awayFilterPersonId.includes(event.person?.id))
        );
      }
    })
    .map((event) => event.id);

  return filteredEventIds;
}
